"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalFunctions = exports.deriveForm = void 0;
const constants_1 = require("../constants");
const resolvers_1 = require("../utils/resolvers");
const execute_logic_1 = __importDefault(require("../utils/execute-logic"));
const functional_1 = require("../utils/functional");
const validators_1 = require("../utils/validators");
const date_string_converter_1 = __importDefault(require("../utils/date-string-converter"));
const friendly_date_string_1 = __importDefault(require("../utils/friendly-date-string"));
const reporter_1 = __importDefault(require("../reporter"));
const getModelItem = (models, modelRef, repeatIndex) => {
    const modelIds = (0, resolvers_1.resolveModelIds)({ models, modelRef, repeatIndex });
    if (!modelIds[0]) {
        // One reason this can happen is if the quote data causes a repeatIndex to be more
        // than the product supports.
        // eslint-disable-next-line no-console
        reporter_1.default.warn({
            modelRef,
            repeatIndex,
        });
    }
    const { id, index } = modelIds[0];
    if (!models[index] || !models[index][id]) {
        throw new Error(`No model data for: ${index}:${id}`);
    }
    return [models[index][id], modelIds];
};
const isVisible = (models, modelRef, repeatIndex) => {
    if (!modelRef)
        return true;
    const [{ meta }] = getModelItem(models, modelRef, repeatIndex);
    return meta && typeof meta.display !== 'undefined' ? meta.display : true;
};
const getAstOrString = (models, astOrString, repeatIndex) => {
    if (typeof astOrString !== 'object')
        return astOrString;
    const [modelData] = getModelItem(models, astOrString.modelRef, repeatIndex);
    return modelData[astOrString.modelRef.attr || constants_1.MODEL_CONTENTS] || '';
};
const getRangeDate = (ast, data) => {
    if (!ast)
        return undefined;
    const val = (0, execute_logic_1.default)({ ast, data });
    const date = typeof val === 'string' ? new Date(...(0, date_string_converter_1.default)(val)) : val;
    return (0, friendly_date_string_1.default)(date);
};
const getValidationMessage = (validators, data) => (type) => {
    const getMessage = validators_1.validationMessages[type];
    const [message, val] = getMessage
        ? getMessage(validators[type], data)
        : ['', undefined];
    return {
        type,
        val,
        message,
    };
};
const getDetails = (models, details, repeatIndex) => details &&
    details
        .map(({ label, value }) => ({
        label: getAstOrString(models, label, repeatIndex),
        value: getAstOrString(models, value, repeatIndex) || '',
    }))
        .filter(({ label }) => label);
const emptyArray = [];
const fieldState = (models, { modelRef, enabled = true, type, validators = {}, details }, repeatIndex) => {
    const [model, context] = getModelItem(models, modelRef, repeatIndex);
    const { meta = {} } = model;
    const { readonly, display: visible } = meta;
    const value = model.value || model[constants_1.MODEL_CONTENTS] || '';
    const isReadOnly = readonly || !enabled;
    if (type === 'button' || type === 'submit') {
        return {
            isReadOnly,
            visible,
            value,
        };
    }
    const { initialValue = '', onReadyValue = '', required = false, validationErrors = emptyArray, } = meta;
    const { range: { start, end } = {} } = validators;
    const data = { models, context, repeatIndex };
    return {
        isReadOnly,
        visible,
        value,
        initialValue,
        onReadyValue,
        pristine: value === onReadyValue,
        valid: !required && (value ? !validationErrors.length : true),
        isRequired: required,
        start: getRangeDate(start, data),
        end: getRangeDate(end, data),
        validationErrors: validationErrors.map(getValidationMessage(validators, data)),
        details: getDetails(models, details, repeatIndex),
    };
};
const deriveForm = (inputs = [], models, fusions, { inFusion = false, repeatIndex, positionContext = [] } = {}) => inputs
    .map((input, inputIndex) => {
    const positionList = [...positionContext, inputIndex + 1];
    const isFusion = inFusion || !!(fusions && fusions[input.fusion]);
    if (input.type === 'group' ||
        (typeof input.type === 'undefined' && input.inputs)) {
        const visible = isVisible(models, input.modelRef, repeatIndex);
        return {
            ...input,
            visible,
            inFusion,
            repeatIndex,
            label: getAstOrString(models, input.label, repeatIndex),
            inputs: visible
                ? (0, exports.deriveForm)(input.inputs, models, fusions, {
                    inFusion: isFusion,
                    repeatIndex,
                    positionContext: positionList,
                })
                : [],
        };
    }
    if (input.type === 'repeat') {
        const count = (0, functional_1.pipe)((0, execute_logic_1.default)({
            ast: input.number,
            data: { models },
        }))(Number, (num) => (Number.isNaN(num) ? 0 : num));
        const repeatInputs = [];
        for (let index = 1; index <= count; index += 1) {
            repeatInputs.push((0, exports.deriveForm)(input.inputs, models, fusions, {
                repeatIndex: index,
                positionContext: [...positionList, index],
            }));
        }
        return {
            ...input,
            count,
            inputs: repeatInputs,
        };
    }
    try {
        const label = getAstOrString(models, input.label, repeatIndex);
        return {
            ...input,
            ...fieldState(models, input, repeatIndex),
            label,
            id: input.id || `REX_${positionList.join('_')}`,
            updates: input.onChange,
            inFusion,
            repeatIndex,
        };
    }
    catch (ex) {
        reporter_1.default.error(ex);
        reporter_1.default.error({ input, repeatIndex });
        return {
            ...input,
            label: `This field has an error.`,
            type: 'error',
            id: input.id || `REX_${positionList.join('_')}`,
            inFusion,
            repeatIndex,
        };
    }
})
    .filter(({ inFusion: fusionChild = false, visible = true, type }) => fusionChild || (visible && type !== 'hidden'));
exports.deriveForm = deriveForm;
// exported for testing
exports.internalFunctions = {
    getRangeDate,
    getValidationMessage,
};
//# sourceMappingURL=derive-form.js.map